var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getPaginatedRequestURL, safeLogError, } from '../../../utils';
function fetchRoles(options = {}) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch(getPaginatedRequestURL('/api/v4/recommendations/roles/', options));
        const data = yield response.json().catch(safeLogError);
        if (!response.ok) {
            throw new Error(`Failed to fetch roles: ${(_a = data === null || data === void 0 ? void 0 : data.detail) !== null && _a !== void 0 ? _a : 'Unknown error'} (${response.status})`);
        }
        return data;
    });
}
export function fetchAllRoles(options, previousResults = []) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const data = yield fetchRoles(options);
        const results = [...previousResults, ...((_a = data.results) !== null && _a !== void 0 ? _a : [])];
        if (data.next) {
            return fetchAllRoles(Object.assign(Object.assign({}, options), { url: data.next }), results);
        }
        return results;
    });
}
//# sourceMappingURL=data.js.map